/**
 * Angular imports.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Service imports.
 */
import { GetwebService } from '../../dataservices/web/getweb.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * FeedDetail Component
 */
@Component({
  selector: 'app-feed-detail',
  templateUrl: './feed-detail.component.html',
  styleUrls: ['./feed-detail.component.scss']
})
export class FeedDetailComponent implements OnInit, OnDestroy {
  public feed_id: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feedMixListData: any;
  public feedMixList = [];
  public isErrorModalShown = false;
  public error_msg: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userProfileData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feeddetaildata: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    public funCollectionService: FunCollectionService,
    private getwebService: GetwebService,
    private masterService: MasterserviceService,
    private route: ActivatedRoute,
    private postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    private dss: DataStorageService
  ) {
    this.subscriptions.add(this.masterService.profile_api_data.subscribe(data => {
      this.userProfileData = data.data;

    }));
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.subscriptions.add(this.route.params.subscribe(params => {
      this.feed_id = params['id'];
    }));
  }


  /**
   * delete Feed Idx
   */
  deleteFeedIdx(feed_idx): void {
    this.subscriptions.add(this.postSer.deleteFeed(this.feedMixList[feed_idx].feed_id).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] === 1) {
          this.feedMixList.splice(feed_idx, 1);
          this.funCollectionService.navigateToHome();
        } else if (data['status'] == 0) {
          this.funCollectionService.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * reset Error Modal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
  }

  /**
   * http Error Handeler
   */
  httpErrorHandeler(err): boolean {

    if (err.error.code == 2000) {
      this.ErrorHandler(err.error.error.msg);
      return false;
    } else if (err.error.error.code == 1002) {
      this.funCollectionService.logout();
    } else {
      this.ErrorHandler(err.error.error.msg);
      return false;
    }
  }

  /**
   * Error Handler
   */
  ErrorHandler(Err_msg): boolean {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
    return false;
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
